// Phantom Residence — media library
// Representative premium architectural imagery. User-uploaded plan/render images
// can be added to PLAN_ITEMS / GALLERY_ITEMS later. category = index in the
// translation filter/category array (0 = "All").

const U = (id, w = 1400) =>
  `https://images.unsplash.com/${id}?auto=format&fit=crop&w=${w}&q=80`;

export const HERO_IMAGE = U("photo-1770839111878-f16c29d5c937", 2000);
export const RESIDENCE_IMAGE = U("photo-1515489472349-73b65ec1247c", 1400);
export const THERMAL_IMAGE =
  "https://images.pexels.com/photos/15083379/pexels-photo-15083379.jpeg?auto=compress&cs=tinysrgb&w=1400";
export const ABOUT_IMAGE = U("photo-1545324418-cc1a3fa10c00", 1200);
export const LOCATION_IMAGE = U("photo-1502920917128-1aa500764cbd", 1400);

// Master plan tab images
export const MASTERPLAN_IMAGES = [
  U("photo-1599696848652-f0ff23bc911f", 1800),
  U("photo-1518005020951-eccb494ad742", 1800),
  U("photo-1486325212027-8081e485255e", 1800),
  U("photo-1545324418-cc1a3fa10c00", 1800),
  U("photo-1497366216548-37526070297c", 1800),
];

// Location map images
export const LOCATION_MAPS = [
  U("photo-1524661135-423995f22d0b", 1400),
  U("photo-1569336415962-a4bd9f69cd83", 1400),
  U("photo-1502920917128-1aa500764cbd", 1400),
];

export const GALLERY_ITEMS = [
  { src: U("photo-1545324418-cc1a3fa10c00"), category: 1, span: "tall" },
  { src: U("photo-1515489472349-73b65ec1247c"), category: 2, span: "tall" },
  { src: U("photo-1486406146926-c627a92ad1ab"), category: 1, span: "" },
  { src: U("photo-1497366811353-6870744d04b2"), category: 3, span: "" },
  { src: U("photo-1502672260266-1c1ef2d93688"), category: 6, span: "" },
  { src: U("photo-1448630360428-65456885c650"), category: 5, span: "tall" },
  { src: U("photo-1496564203457-11bb12075d90"), category: 4, span: "" },
  { src: U("photo-1480714378408-67cf0d13bc1b"), category: 5, span: "" },
  { src: U("photo-1493809842364-78817add7ffb"), category: 4, span: "tall" },
  { src: U("photo-1554995207-c18c203602cb"), category: 6, span: "" },
  { src: U("photo-1512453979798-5ea266f8880c"), category: 2, span: "" },
  { src: U("photo-1564013799919-ab600027ffc6"), category: 1, span: "" },
];

// Plan documents. title is multilingual. category = plan category index.
export const PLAN_ITEMS = [
  {
    src: U("photo-1497366216548-37526070297c"),
    category: 1,
    title: { tr: "Proje Genel Tanıtımı", en: "Project Overview", ar: "نظرة عامة على المشروع", ru: "Обзор проекта" },
  },
  {
    src: U("photo-1524661135-423995f22d0b"),
    category: 2,
    title: { tr: "Lokasyon Haritası", en: "Location Map", ar: "خريطة الموقع", ru: "Карта локации" },
  },
  {
    src: U("photo-1599696848652-f0ff23bc911f"),
    category: 3,
    title: { tr: "Genel Vaziyet Planı", en: "General Site Plan", ar: "المخطط العام", ru: "Генеральный план" },
  },
  {
    src: U("photo-1515489472349-73b65ec1247c"),
    category: 4,
    title: { tr: "Rezidans + Otel Görseli", en: "Residence + Hotel Visual", ar: "صورة السكن + الفندق", ru: "Резиденция + Отель" },
  },
  {
    src: U("photo-1486325212027-8081e485255e"),
    category: 5,
    title: { tr: "C Blok Teknik Bilgiler", en: "Block C Technical Info", ar: "معلومات تقنية للبلوك C", ru: "Техинфо блока C" },
  },
  {
    src: U("photo-1503387762-592deb58ef4e"),
    category: 6,
    title: { tr: "Kat Planı", en: "Floor Plan", ar: "مخطط الطابق", ru: "План этажа" },
  },
  {
    src: U("photo-1493809842364-78817add7ffb"),
    category: 7,
    title: { tr: "Daire Tipi", en: "Apartment Type", ar: "نوع الشقة", ru: "Тип квартиры" },
  },
  {
    src: U("photo-1502672260266-1c1ef2d93688"),
    category: 8,
    title: { tr: "Ticari Alan Planı", en: "Commercial Area Plan", ar: "مخطط المساحة التجارية", ru: "План коммерческой зоны" },
  },
  {
    src: U("photo-1564013799919-ab600027ffc6"),
    category: 9,
    title: { tr: "Otel / Ramada Alanı", en: "Hotel / Ramada Area", ar: "منطقة الفندق / رمادا", ru: "Зона отеля / Ramada" },
  },
  {
    src: THERMAL_IMAGE,
    category: 10,
    title: { tr: "Termal & Sağlık Tesisi", en: "Thermal & Health Facility", ar: "المنشأة الحرارية والصحية", ru: "Термальный комплекс" },
  },
  {
    src: U("photo-1497366811353-6870744d04b2"),
    category: 6,
    title: { tr: "Kat Planı — Tip B", en: "Floor Plan — Type B", ar: "مخطط الطابق — نوع B", ru: "План этажа — Тип B" },
  },
  {
    src: U("photo-1503387762-592deb58ef4e"),
    category: 7,
    title: { tr: "Daire Tipi — 2+1", en: "Apartment Type — 2+1", ar: "نوع الشقة — 2+1", ru: "Тип квартиры — 2+1" },
  },
];
